// extracted by mini-css-extract-plugin
export default {"other":"OtherVacancies_other__17EpI"};